import React from 'react'
import { Box } from '@mui/material'
import { Field } from 'react-final-form'
import VideoUploader from '../components/VideoUploader'
import VideoViewer from '../components/VideoViewer'
import { useParams } from 'react-router-dom'

import { getTextVideoModuleStyles } from '../styles/videoStyles'

export default function TextVideoModule({ name, isPreview = false, data, isCurrentThemeLight }) {
  const { topicId } = useParams()

  const styles = getTextVideoModuleStyles(isCurrentThemeLight)

  if (isPreview && data) {
    return (
      <Box sx={styles.previewContainer}>
        {data.url && (
          <Box sx={styles.previewVideoContainer}>
            <VideoViewer url={data.url} alt={data.title} />
          </Box>
        )}
      </Box>
    )
  }

  return (
    <Box sx={styles.container}>
      <Field name={`${name}.url`}>
        {({ input }) => (
          <Box sx={styles.uploaderContainer}>
            <VideoUploader
              topicId={topicId}
              url={input.value}
              onVideoChange={input.onChange}
              onVideoRemove={() => input.onChange('')}
              isCurrentThemeLight={isCurrentThemeLight}
            />
          </Box>
        )}
      </Field>
    </Box>
  )
}
